<template>
	<div class="district-draw">
		<div class="district-draw-left">
			<Tree @changeSwitch="changeSwitch" :switchVal="switchVal" title="是否显示下级" @nodeClick="nodeClick"></Tree>
		</div>
		<div class="district-draw-right">
			<div id="map-container" style="width: 100%;height: 100%"></div>
			<div class="btn_tool">
				<div style="margin-right: 10px;">当前区域：{{currentCenter ? currentCenter.name : ''}}</div>
				<div class="btn">
					<el-button :disabled="isSubmitDisabled" type="success" size="mini" @click="submit">提交</el-button>
					<el-button :disabled="isEditDisabled" type="warning" size="mini" @click="enableEditingPolygon">编辑</el-button>
					<el-button :disabled="!isEditDisabled" type="success" size="mini" @click='addACPoly'>新增</el-button>
					<el-button :disabled="isEditDisabled" type="danger" size="mini" @click="deletePloy">删除</el-button>
					<el-button size="mini" @click="changePage">切换列表</el-button>
				</div>
			</div>
		</div>

		<div class="alarmCentreMgt-map-priority-panel flex-row-vc" v-if="isVisible" ref="polygonPanel">
			<div class="polygon-close" @click="handleCancel()">
				<i class="el-icon-close"></i>
			</div>
			<div class="map-priority-panel-title flex-row">
				<div class="map-priority-panel-title-tab" :class="{'selected': showPriorityTab === 1}" @click="togglePriorityTab(1)">优先级设置</div>
				<div class="map-priority-panel-title-tab" :class="{'selected': showPriorityTab === 2}" @click="togglePriorityTab(2)">查看接警中心信息</div>
			</div>
			<div class="priority-panel" v-if="showPriorityTab === 1">
				<div class="priority-panel-container">
					<ul class="priority-panel-list">
						<li class="priority-panel-header flex-row">
							<div class="priority-panel-column-1">指挥中心名称</div>
							<div class="priority-panel-column-2">优先级</div>
						</li>
						<div class="priority-panel-content">
							<li v-for="(item,index) in priorityMapping" :key="index" class="flex-row">
								<div class="priority-panel-column-1">{{item.name}}</div>
								<div class="priority-panel-column-2">
									<!-- <el-input-number v-model="item.priority" controls-position="right" :min="1"></el-input-number> -->
									<input type="number" v-model="item.priority" min="1">
								</div>
							</li>
						</div>
					</ul>
					<div class="priority-panel-btn-section">
						<div class="priority-panel-btn" @click="savePriority()">保存</div>
					</div>
				</div>
			</div>
			<div class="priority-panel" v-if="showPriorityTab === 2">
				<div class="info-panel-container flex-row-vc">
					<div class="info-content">
						<ul v-for="(info,index) in priorityMapping" :key="index">
							<ul v-if="index === (infoCurrent - 1)">
								<li class="info-content-row flex-row">
									<div class="info-content-label">名称</div>
									<div class="info-content-value">{{info.name}}</div>
								</li>
								<li class="info-content-row flex-row">
									<div class="info-content-label">区域</div>
									<div class="info-content-value">{{info.name}}</div>
								</li>
								<li class="info-content-row flex-row">
									<div class="info-content-label">位置</div>
									<div class="info-content-value">{{info.address}}</div>
								</li>
								<li class="info-content-row flex-row">
									<div class="info-content-label">优先级</div>
									<div class="info-content-value">{{info.priority}}</div>
								</li>
							</ul>
						</ul>
					</div>

					<div class="info-pager flex-row">
						<div class="info-pager-prev" @click="prevPage()"><i class="el-icon-back"></i></div>
						<div class="info-pager-current">第{{infoCurrent}}页</div>
						<div class="info-pager-total">/共{{priorityMapping.length}}页</div>
						<div class="info-pager-next" @click="nextPage()"><i class="el-icon-right"></i></div>
					</div>

				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import AMap from 'AMap'
	import Tree from '../../../../components/Tree/nodeTreeDistrict.vue';
	import {
		districtApi
	} from '../../../../api-path/district-api.js'
	export default {
		components: {
			Tree
		},
		data() {
			return {
				isVisible: false,
				map: '',
				currentCenter: {
					longitude: '',
					latitude: '',
					id: ''
				},
				marker: '', //当前指挥中心的定点
				polygon: '', //当前指挥中心的热点
				polygons: [], //该指挥中心及下级指挥中心热点（根据筛选条件）
				isSubmitDisabled: true, //是否可以点击提交按钮
				isEditDisabled: true, //是否可以点击编辑按钮
				mouseTool: '', //地图绘制工具
				overlays: [], //地图上显示的热点（用于绘图）
				polygonPathList: [], //当前指挥中心热点的坐标
				polygonMapping: [], //该指挥中心及下级指挥中心热点（id为key的集合，用于判断两个多边形是否相交）
				colorList: ['#D6F8F6', '#78AAF2', '#9177D9'], //颜色池
				colors: [],
				selectedColors: {
					fill: '#FD2423',
					stroke: '#333'
				},
				currentPolyEditor: '', //当前热点编辑工具
				priorityMapping: [], // 相交的指挥中心集合
				showPriorityTab: 1, //点击热区显示的tab页，1是设置优先级 2是指挥中心详情
				infoCurrent: 1, //第几个指挥中心详情
				pointList: [], //保存热区时用于存放多边形多个角的经纬度
				remark: '',

				data: [],
				switchVal: false,
				areaId: '', //当前选中的areaId
				isDown: false, //是否查询下级
				isDelete: false,
			}
		},
		mounted() {
			// this.getHotArea()
		},
		methods: {
			//
			changePage(){
				this.$router.go(-1);
			},
			// 删除热区
			deletePloy() {
				this.isSubmitDisabled = false;
				this.isDelete = true;
			},

			// 初始化地图
			initMap() {
				let $this = this;
				this.map = new AMap.Map('map-container', {
					center: [106.638594, 29.487478],
					zoom: 16,
					zooms: [6, 21]
				});
				AMap.plugin(["AMap.MouseTool"], function() {
					$this.mouseTool = new AMap.MouseTool($this.map);
				});

				// 监听draw事件可获取画好的覆盖物
				$this.mouseTool.on('draw', function(e) {
					if (e.obj.CLASS_NAME === 'AMap.Polygon') {
						$this.map.remove($this.overlays);
						$this.overlays = [];
						$this.overlays.push(e.obj);
						let polygonData = e.obj.toString();
						$this.polygonPathList = polygonData.split(';');
					} else {
						if (e.obj.getRadius && e.obj.getRadius() <= 10) {
							return;
						}
						$this.map.remove($this.overlays);
						$this.overlays = [];
						$this.overlays.push(e.obj);
					}

				});
			},

			//开启地图绘制工具
			addACPoly() {
				this.mouseTool.polygon({
					fillColor: '#1791fc',
					strokeColor: '#1791fc',
					strokeWeight: 4,
					strokeOpacity: 0.8,
					fillOpacity: 0.4
				});
				this.isSubmitDisabled = false;
			},
			//左侧树点击事件调用该方法，刷新地图，将当前点击指挥中心设为中心点。
			refresh(data) {
				this.infoCurrent = 1;
				//去除所有多边形
				this.polygons.forEach(item => {
					this.map.remove(item);
				});

				if (this.polygon != null) {
					this.map.remove(this.polygon);
				}
				if (this.marker) {
					this.marker.setMap(null);
					this.marker = null;
				}

				this.polygons = [];
				this.polygon = null;
				this.alarmCentreMapping = [];
				if (this.currentPolyEditor) {
					this.currentPolyEditor.close();
				}

				data.forEach(item => {
					this.colors['poly' + item.id] = {
						fill: this.colorList[0],
						stroke: '#333'
					};
					if (item.hotArea) {
						this.alarmCentreMapping.push(item);
						this.createPolygon(item.id, item.longitude, item.latitude, item.hotArea, this.colors, this.selectedColors,
							this.polygonClicked,item);
					} else {
						if (item.id === this.currentCenter.id) {
							this.map.setZoomAndCenter(11, [item.longitude, item.latitude]);
							this.marker = new AMap.Marker({
								// icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
								position: [item.longitude, item.latitude],
								offset: new AMap.Pixel(-13, -30)
							});
							this.marker.setMap(this.map);

						}
					}
				});
				// 判断是否能编辑，
				if (this.polygon == null) {
					this.isEditDisabled = true;
				} else {
					this.isEditDisabled = false;
				}

			},

			//热区点击事件
			polygonClicked(data) {

				let $this = data.$this;
				$this.infoCurrent = 1;

				$this.isVisible = true;

				let id = data.mark.replace('poly', '');
				// $this.getCurrentCenter(id);
				let selectedCenter;
				$this.alarmCentreMapping.forEach(item => {
					if (item.id == id) {
						selectedCenter = item;
					}
				});
				data.$this.priorityMapping = [];
				data.$this.findAllContainsPoly(data.mark, data.$this);

				$this.priorityMapping.push(selectedCenter);
			},


			findAllContainsPoly(mark, $this) {

				$this.alarmCentreMapping.forEach(item => {
					let targetMark = 'poly' + item.id;
					if (mark != targetMark) {
						if ($this.doesRingRingIntersect(mark, targetMark) || $this.isRingInRing(mark, targetMark) || $this.isRingInRing(
								targetMark, mark)) {
							$this.priorityMapping.push(item);
						}
					}

				});
			},

			doesRingRingIntersect(mark1, mark2) {
				if (!this.polygonMapping[mark1]) {
					return false;
				}
				if (!this.polygonMapping[mark2]) {
					return false;
				}
				let path1 = this.polygonMapping[mark1].getPath();
				let path2 = this.polygonMapping[mark2].getPath();
				let result = AMap.GeometryUtil.doesRingRingIntersect(path1, path2);
				return result;
			},

			isRingInRing(mark1, mark2) {
				if (!this.polygonMapping[mark1]) {
					return false;
				}
				if (!this.polygonMapping[mark2]) {
					return false;
				}
				let path1 = this.polygonMapping[mark1].getPath();
				let path2 = this.polygonMapping[mark2].getPath();
				let result = AMap.GeometryUtil.isRingInRing(path1, path2);
				return result;
			},

			handleCancel() {
				this.isVisible = false;
			},

			//在地图上加载热区方法
			createPolygon(id, longitude, latitude, pathList, colors, selectedColors, clickedCallback, citem) {
				let mark = 'poly' + id;
				let newPathlist = [];
				pathList.forEach((item) => {
					let a = [];
					a.push(item.lng);
					a.push(item.lat);
					newPathlist.push(a);
				});
				let polygon = new AMap.Polygon({
					path: newPathlist,
					fillColor: colors[mark].fill,
					strokeColor: colors[mark].stroke,
					strokeStyle: 'dashed',
					strokeWeight: 3,
					strokeOpacity: 0.2,
					fillOpacity: 0.4,
					cursor: 'pointer'
				});
				polygon.on('click', function(e) {

					// let containsList = [];
					let lnglat = [e.lnglat.lng, e.lnglat.lat];
					for (let polyKey in this.polygonMapping) {
						this.polygonMapping[polyKey].setOptions({
							fillColor: colors[polyKey].fill,
							strokeColor: colors[polyKey].stroke
						});
						this.polygonMapping[polyKey].setExtData({
							'selected': false
						});
						// if(self.polygonMapping[polyKey].contains(lnglat)) {
						//   containsList.push(polyKey);
						// }
					}
					polygon.setOptions({
						fillColor: selectedColors.fill,
						strokeColor: selectedColors.stroke
					});
					polygon.setExtData({
						'selected': true
					});
					clickedCallback({
						'mark': mark,
						'lnglat': lnglat,
						'$this': $this
					});
					// this.emit('polygonClicked', {'mark': mark, 'lnglat': lnglat, 'alarmCentreMapping': alarmCentreMapping});
				});
				polygon.on('mouseover', function() {
					polygon.setOptions({
						fillColor: selectedColors.fill,
						strokeColor: selectedColors.stroke
					});
				});
				polygon.on('mouseout', function() {
					if (!polygon.getExtData().selected) {
						polygon.setOptions({
							fillColor: colors[mark].fill,
							strokeColor: colors[mark].stroke
						});
					}
				});
				polygon.itemInfo = citem;
				this.map.add(polygon);
				this.polygonMapping[mark] = polygon;
				this.polygons.push(polygon);
				let polyEditor = '';
				let $this = this;
				AMap.plugin(["AMap.PolyEditor"], function() {
					polyEditor = new AMap.PolyEditor($this.map, polygon);
				});
				polyEditor.on('adjust', function(event) {
					let polygonData = event.target.toString();
					$this.polygonPathList = polygonData.split(';');
				});
				// this.polyEditorMapping[mark] = polyEditor;

				if (this.currentCenter && id == this.currentCenter.id) {
					this.polygon = polygon;
					this.map.setZoomAndCenter(11, [longitude, latitude]);
					this.currentPolyEditor = polyEditor;
					this.marker = new AMap.Marker({
						// icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
						position: [longitude, latitude],
						offset: new AMap.Pixel(-13, -30)
					});
					this.marker.setMap(this.map);

				}
			},

			//保存热区及中心点经纬度
			submit() {
				this.isSubmitDisabled = true;
				if (this.currentPolyEditor) {
					this.currentPolyEditor.close();
				}
				this.mouseTool.close(true);

				let points;
				let sumLongitude = 0.0;
				let sumLatitude = 0.0;
				this.pointList = [];

				if (this.polygonPathList != null) {
					this.polygonPathList.forEach(item => {
						var a = {};
						const arr = item.split(',');
						a['lng'] = arr[0];
						a['lat'] = arr[1];
						this.pointList.push(a);
					});
				}


				if (this.pointList.length > 0) {
					let X = 0,
						Y = 0,
						Z = 0;
					let total = this.pointList.length;
					points = this.pointList;
					this.currentCenter.hotArea = this.pointList;

					//计算中心点的经纬度
					for (let i = 0; i < total; i++) {
						sumLongitude = this.pointList[i].lng * Math.PI / 180;
						sumLatitude = this.pointList[i].lat * Math.PI / 180;
						let x, y, z;
						x = Math.cos(sumLatitude) * Math.cos(sumLongitude);
						y = Math.cos(sumLatitude) * Math.sin(sumLongitude);
						z = Math.sin(sumLatitude);
						X += x;
						Y += y;
						Z += z;
					}
					X = X / total;
					Y = Y / total;
					Z = Z / total;
					let Lng = Math.atan2(Y, X);
					let Hyp = Math.sqrt(X * X + Y * Y);
					let Lat = Math.atan2(Z, Hyp);
					sumLongitude = (Lng * 180 / Math.PI);
					sumLatitude = (Lat * 180 / Math.PI);
					this.currentCenter.longitude = sumLongitude;
					this.currentCenter.latitude = sumLatitude;
				}


				let value = {};
				value['id'] = this.currentCenter.id;
				value['hotArea'] = points;
				value['priority'] = 1;
				value['longitude'] = sumLongitude;
				value['latitude'] = sumLatitude;
				console.log(this.polygon);
				if (this.isDelete) {
					this.$http.post(`${districtApi.delHotArea}/${this.polygon.itemInfo.id}`).then(res => {
						if (res.status === 200) {
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
							this.map.remove(this.polygon);
							this.polygon = null;
							this.polygonPathList = null;
							this.isDelete = false;
							this.isEditDisabled = true
							// this.getHotArea();
						}
					})
				} else {
					this.$http.post(districtApi.saveHotArea, value).then(res => {
						if (res.status === 200) {
							this.$message({
								type: 'success',
								message: '操作成功!',
							});
							this.isVisible = false;
							// this.getHotArea();
						}
					})
				}
				this.data = [];
				this.getHotArea()

			},

			//热区编辑功能开始
			enableEditingPolygon() {
				this.isSubmitDisabled = false;
				this.currentPolyEditor.open();
			},


			//触发主页面监听事件
			loadList() {
				this.loadParentList.emit();
			},
			getCurrentCenter(id) {
				this.loadClick.emit(id);
			},

			// 切换tab页
			togglePriorityTab(tabIndex) {
				this.showPriorityTab = tabIndex;
			},

			// 保存优先级
			savePriority() {
				// let array = [];
				let params = [];
				let boo = false;
				this.priorityMapping.forEach((item) => {
					if (item.priority < 1) {
						boo = true;
					}
					const obj = {
						id: item.id,
						priority: item.priority
					};
					params.push(obj);
				});

				if (boo) {
					this.message.error('优先级不能小于1');
					return;
				}
				this.$http.post(districtApi.savePriority,{priorities:params}).then(res=>{
					if(res.status===200){
							this.$message({
								type: 'success',
								message: '操作成功!',
							});
						this.isVisible = false
					}
				})
			},

			prevPage() {
				if (this.infoCurrent > 1) {
					this.infoCurrent--;
				}
			},

			nextPage() {
				if (this.infoCurrent < this.priorityMapping.length) {
					this.infoCurrent++;
				}
			},
			bindMap() {
				this.initMap();
				this.polygons = [];
				this.polygon = null;
				this.alarmCentreMapping = [];
				// if(this.data.length===0){
				// }
				this.map.setZoomAndCenter(11, [this.currentCenter.longitude, this.currentCenter.latitude]);
				//在地图上加载需要显示的指挥中心的热区
				this.data.forEach(item => {
					this.colors['poly' + item.id] = {
						fill: this.colorList[0],
						stroke: '#333'
					};
					// 设置指挥中心的经纬度为地图中心点
					if (this.currentCenter && item.id == this.currentCenter.id) {
						this.map.setZoomAndCenter(11, [item.longitude, item.latitude]);
					}

					if (item.hotArea) {
						console.log(item.name);
						this.alarmCentreMapping.push(item);
						this.createPolygon(item.id, item.longitude, item.latitude, item.hotArea, this.colors, this.selectedColors,
							this.polygonClicked,item);

					}
				});
				//选中指挥中心有热区是开启编辑功能
				if (this.polygon != null) {
					setTimeout(() => {
						this.isEditDisabled = false;
					});
				}

			},
			//获取区域
			getHotArea() {
				this.$http.get(`${districtApi.queryCenterByHotArea}?areaId=${this.areaId}&isDown=${this.isDown}&page=1&size=100000`).then(
					res => {
						if (res.status == 200) {
							this.data=res.result.pageList;
							this.bindMap();
						}
					})
			},
			// -----------------
			nodeClick(node) {
				this.areaId = node.id;
				this.currentCenter.id = node.id;
				this.currentCenter.name = node.id?node.name:"";
				this.currentCenter.longitude = node.longitude;
				this.currentCenter.latitude = node.latitude;
				this.data = [];
				this.isEditDisabled=true;
				this.isSubmitDisabled=true;
				this.getHotArea()
				
			},
			changeSwitch(e) {
				this.isDown = e;
				this.data = [];
				this.getHotArea()
			},
		}
	}
</script>

<style lang="less" scoped>
	.district-draw {
		margin: 0 10px 10px 10px;
		box-sizing: border-box;
		height: 100%;
		padding: 20px 10px;
		border-radius: 10px;
		background: #fff;
		display: flex;

		.district-draw-left {
			margin-right: 10px;
			border-right: 1px solid #c1c1c1;
			/*overflow-y: scroll;*/
			overflow-x: scroll;

			.plug-tree {}
		}

		.district-draw-right {
			flex: 1;
			position: relative;

			.btn_tool {
				position: absolute;
				top: 20px;
				display: flex;
				align-items: center;
				background: #fff;
				padding: 5px 20px;
				border-radius: 19px;
				box-shadow: 10px 10px 20px #ccc;
			}
		}

		.alarmCentreMgt-map-priority-panel {
			height: 256px;
			padding: 10px 20px;
			width: 256px;
			z-index: 900;
			border-radius: 8px;
			font-size: 14px;
			background-color: rgba(255, 255, 255, .8);
			box-shadow: 2px 2px 2px #888;
			color: #333;
			position: absolute;
			top: calc(50% - 150px);
			left: calc(50% - 150px);
		}

		.flex-row-vc {
			display: flex;
			display: -webkit-flex;
			display: -moz-flex;
			display: -ms-flexbox;
			-webkit-flex-direction: column;
			-moz-flex-direction: column;
			-ms-flex-direction: column;
			-o-flex-direction: column;
			flex-direction: column;
		}

		.map-priority-panel-title-tab {
			flex: 1 0 50%;
			width: 50%;
			cursor: pointer;
		}

		.alarmCentreMgt-map-priority-panel {
			/* position: absolute; */
			height: 296px;
			/* line-height: 34px; */
			padding: 10px 20px;
			width: 296px;
			z-index: 900;
			/* top: 40px; */
			/* right: 20px; */
			border-radius: 8px;
			font-size: 14px;
			background-color: rgba(255, 255, 255, .8);
			box-shadow: 2px 2px 2px #888;
			color: #333;
		}

		.polygon-close {
			position: absolute;
			right: 7px;
			top: 7px;
			cursor: pointer;
		}

		.map-priority-panel-title {
			flex: 0 0 20px;
		}

		.map-priority-panel-title-tab {
			flex: 1 0 50%;
			width: 50%;
			cursor: pointer;
		}

		.map-priority-panel-title-tab.selected {
			color: #0290D4;
		}

		.map-priority-panel-title-tab:first-child {
			border-right: 1px solid #ccc;
			margin-right: 10px;
		}

		.priority-panel {
			flex: 1;
			height: 100%;
		}

		.priority-panel-container {
			height: calc(100% - 44px);
			background: rgba(48, 48, 48, .2);
			margin: 10px 0;
			padding-left: 0px !important;
		}

		.priority-panel-header {
			background-color: rgba(48, 48, 48, .6);
			color: #fff;
			padding: 5px 0;
		}

		.priority-panel-list {
			height: 100%;
			overflow: hidden;
			padding-left: 0px !important;
		}

		.priority-panel-content {
			height: calc(100% - 30px);
			overflow: auto;
		}

		.priority-panel-content::-webkit-scrollbar {
			width: 20px;
			height: 2px;
			background: #ccc;
			border-radius: 10px;
			/*外层轨道*/
		}

		.priority-panel-content::-webkit-scrollbar-thumb {
			display: block;
			width: 6px;
			margin: 0 auto;
			border-radius: 10px;
			background: #B2B2B2;
			/*内层轨道*/
			cursor: pointer;
		}

		.priority-panel-content-row {
			margin-bottom: 3px;
		}

		.priority-header-column {
			text-align: center;
		}

		.priority-panel-column-1 {
			flex: 0 0 61.8%;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			text-align: center;
		}

		.priority-panel-column-2 {
			flex: 0 0 38.2%;
			text-align: center;
		}

		.priority-panel-column-2 input {
			width: 100%;
			background: rgba(0, 0, 0, 0);
			border: none;
			outline: none;
			text-align: center;
		}

		.priority-panel-btn-section {
			height: 34px;
			line-height: 34px;
			text-align: right;
		}

		.priority-panel-btn {
			text-align: center;
			display: inline;
			background: #0290D4;
			border-radius: 4px;
			padding: 2px 5px;
			color: #fff;
			font-size: 12px;
			cursor: pointer;
		}

		.info-panel-container {
			height: 100%;
		}

		.info-content {
			margin: 10px 0;
			border: 1px solid #ccc;
			flex: 1;
			max-height: 180px;
		}

		.info-content-row {
			margin-bottom: 3px;
		}

		.info-content-label {
			flex: 0 0 38.2%;
			text-align: center;
			padding-right: 10px;
		}

		.info-pager {
			justify-content: center;
			align-items: center;
			margin: 5px 0;
			/* color: #fff; */
		}

		.info-pager-prev,
		.info-pager-next {
			cursor: pointer;
		}

		.alarmCentre-detail-input .el-input__icon {
			line-height: 34px;
		}

		.alarmCentreMgt-section-right {
			flex: 1;
		}

		.alarmCentreMgt-map-toolbar {
			position: absolute;
			height: 34px;
			line-height: 34px;
			padding: 0 10px;
			/* width: 200px; */
			z-index: 900;
			top: 40px;
			left: 340px;
			border-radius: 8px;
			font-size: 14px;
			background-color: #fff;
			box-shadow: 2px 2px 2px #888;
			color: #333;
		}

		.alarmCentreMgt-map-toolbar .map-toolbar-btn {
			font-size: 12px;
			margin: 5px 0 5px 10px;
			line-height: 25px;
			text-align: center;
			border-radius: 4px;
			cursor: pointer;
			height: 25px;
		}

		.flex-row {
			display: flex;
		}
	}
</style>
